import _ from "@babel/runtime/helpers/esm/objectSpread2";
import z from "@babel/runtime/helpers/esm/classCallCheck";
import x from "@babel/runtime/helpers/esm/createClass";
import m from "@babel/runtime/helpers/esm/assertThisInitialized";
import P from "@babel/runtime/helpers/esm/inherits";
import V from "@babel/runtime/helpers/esm/createSuper";
import i from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as j } from "@semcore/utils/lib/core/index";
import E, { sstyled as h, assignProps as p, Component as b } from "@semcore/core";
import a from "react";
import R from "@semcore/icon/Search/m";
import T from "@semcore/icon/Close/m";
import S from "@semcore/input";
import { ButtonLink as k } from "@semcore/button";
import { selectContext as M } from "./context.mjs";
import O from "@semcore/utils/lib/enhances/i18nEnhance";
import { localizedMessages as v } from "./translations/__intergalactic-dynamic-locales.mjs";
var w = (
  /*__reshadow_css_start__*/
  (j.insert(
    /*__inner_css_start__*/
    ".___SInputSearch_ozdj6_gg_._size_m_ozdj6_gg_{height:32px}.___SSearchClear_ozdj6_gg_{padding:0 var(--intergalactic-spacing-2x, 8px)}.___SSearchClear_ozdj6_gg_.__hide_ozdj6_gg_{visibility:hidden}.___SOutline_ozdj6_gg_{top:-1px;left:-1px;width:100%;border-radius:var(--intergalactic-control-rounded, 6px) var(--intergalactic-control-rounded, 6px)0 0;box-sizing:content-box}",
    "ozdj6_gg_"
  ), {
    __SInputSearch: "___SInputSearch_ozdj6_gg_",
    _size_m: "_size_m_ozdj6_gg_",
    __SSearchClear: "___SSearchClear_ozdj6_gg_",
    _hide: "__hide_ozdj6_gg_",
    __SOutline: "___SOutline_ozdj6_gg_"
  })
), s = /* @__PURE__ */ function(u) {
  P(n, u);
  var o = V(n);
  function n() {
    var e;
    z(this, n);
    for (var r = arguments.length, t = new Array(r), l = 0; l < r; l++)
      t[l] = arguments[l];
    return e = o.call.apply(o, [this].concat(t)), i(m(e), "inputRef", /* @__PURE__ */ a.createRef()), i(m(e), "closeIconRef", /* @__PURE__ */ a.createRef()), i(m(e), "handleClear", function(d) {
      e.handlers.value("", d), setTimeout(function() {
        if (document.activeElement === document.body || document.activeElement === e.closeIconRef.current) {
          var c;
          (c = e.inputRef.current) === null || c === void 0 || c.focus();
        }
      }, 0);
    }), e;
  }
  return x(n, [{
    key: "uncontrolledProps",
    value: function() {
      return {
        value: null
      };
    }
  }, {
    key: "getValueProps",
    value: function() {
      var r = this.asProps.getI18nText;
      return {
        autoFocus: !0,
        ref: this.inputRef,
        placeholder: r("Select.InputSearch.Value:placeholder"),
        "aria-label": r("Select.InputSearch.Value:aria-label")
      };
    }
  }, {
    key: "getClearProps",
    value: function() {
      var r = this.asProps, t = r.value, l = r.getI18nText;
      return {
        ref: this.closeIconRef,
        /* hide through css because the width of the input changes */
        hide: !t,
        "aria-hidden": !t,
        "aria-label": l("clearSearch"),
        onClick: this.handleClear
      };
    }
  }, {
    key: "render",
    value: function() {
      var r = this.asProps, t, l = f.Value, d = S, c = this.asProps, C = c.size, g = c.styles, I = c.children, y = c.Children;
      return t = h(g), /* @__PURE__ */ a.createElement(d, t.cn("SInputSearch", {
        size: C || this.context.size || "m",
        styles: g
      }), I ? /* @__PURE__ */ a.createElement(y, t.cn("Children", {})) : /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(f.SearchIcon, null), /* @__PURE__ */ a.createElement(l, t.cn("Value", _({}, p({}, r)))), /* @__PURE__ */ a.createElement(f.Clear, null)));
    }
  }]), n;
}(b);
i(s, "displayName", "InputSearch");
i(s, "style", w);
i(s, "enhance", [O(v)]);
i(s, "defaultProps", {
  defaultValue: "",
  i18n: v,
  locale: "en"
});
i(s, "contextType", M);
var A = function(o) {
  var n = arguments[0], e, r = S.Addon, t = o.styles;
  return e = h(t), /* @__PURE__ */ a.createElement(r, e.cn("SSearchIcon", _({}, p({}, n))), /* @__PURE__ */ a.createElement(R, e.cn("SearchM", {})));
}, F = function(o) {
  var n = arguments[0], e, r = S.Value, t = o.styles;
  return e = h(t), /* @__PURE__ */ a.createElement(r, e.cn("SSearchValue", _({}, p({}, n))));
}, L = function(o) {
  var n = arguments[0], e, r = k, t = o.styles;
  return e = h(t), /* @__PURE__ */ a.createElement(r, e.cn("SSearchClear", _({}, p({
    addonLeft: T,
    use: "secondary"
  }, n))));
}, f = E(s, {
  SearchIcon: A,
  Value: F,
  Clear: L
});
export {
  f as default
};
